module.exports = __webpack_public_path__ + "media/useful-video.6e74dd93.mp4";